<template>
  <!-- Layout exclusivo para Login (pantalla completa sin sidebars ni headers) -->
  <div v-if="route.name === 'login'" class="h-screen w-screen overflow-hidden">
    <router-view></router-view>
  </div>

  <!-- Layout para el resto de la aplicación (Dashboard) -->
  <div v-else class="grid grid-cols-2-small h-screen overflow-hidden" :class="{ 'grid-cols-2-menu': activeParent }">
    <!-- header del sistema -->
    <Nav />
    <main class="h-screen overflow-hidden flex flex-col" :class="{ 'dashboard-bg': route.name === 'HomePage' }">
      <HeaderHome @actualizar-propiedad="activeParent = $event" />
      <!-- espacio donde se va a rederisar todos los componentes -->
      <router-view class="flex-1 min-h-0 overflow-y-auto pl-4 pr-6 pt-5 pb-8"> </router-view>
    </main>
  </div>

  <!-- Overlay móvil: cierra el menú al tocar fuera -->
  <div v-if="route.name !== 'login' && activeParent" class="fixed inset-0 bg-black/40 z-40 md:hidden"
    @click="activeParent = false"></div>

  <div id="container-pdf"></div>

  <!-- Componente PWA para instalación inteligente - DEBE estar fuera del grid -->
  <InstallPWA @installed="handlePWAInstalled" @dismissed="handlePWADismissed" />
</template>

<script>
import Nav from "./components/Nav/Nav.vue";
import HeaderHome from "./components/Nav/Header.vue";
import InstallPWA from "./components/PublicComponents/InstallPWA.vue";
import { useRoute } from 'vue-router'
export default {
  name: "App",
  components: {
    Nav,
    HeaderHome,
    InstallPWA,
  },
  data() {
    return {
      activeParent: false,
    };
  },
  setup() {
    const route = useRoute()
    return { route }
  },
  methods: {
    handlePWAInstalled() {
      console.log('PWA instalada exitosamente');
    },
    handlePWADismissed() {
      console.log('Usuario rechazó instalar PWA');
    }
  }
};
</script>
<style>
.grid-cols-2-small {
  grid-template-columns: 255px 1fr;
}

.grid-cols-2-small.grid-cols-2-menu {
  grid-template-columns: 70px 1fr;
  transition: all 0.25s;
}

.grid-cols-2-small.grid-cols-2-menu .small-hidden {
  display: none;
}

.grid-cols-2-small.grid-cols-2-menu .small-center {
  justify-content: center;
}

@media screen and (max-width: 768px) {

  /* En móvil el layout es 1 columna; el nav se vuelve overlay */
  .grid-cols-2-small {
    grid-template-columns: 1fr;
    transition: all 0.25s;
  }

  .grid-cols-2-small>nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 255px;
    min-width: 255px;
    height: 100vh;
    height: 100dvh;
    height: -webkit-fill-available;
    transform: translateX(-100%);
    transition: transform 0.25s;
    z-index: 50;
  }

  .grid-cols-2-small.grid-cols-2-menu>nav {
    transform: translateX(0);
  }

  .grid-cols-2-small .small-hidden {
    display: none;
  }

  .grid-cols-2-small .small-center {
    justify-content: center;
  }

  .grid-cols-2-small.grid-cols-2-menu {
    grid-template-columns: 1fr;
    transition: all 0.25s;
  }

  .grid-cols-2-small.grid-cols-2-menu .small-hidden {
    display: inline-flex;
  }

  .grid-cols-2-small.grid-cols-2-menu .small-center {
    justify-content: start;
  }
}

/* Eliminar las flechas del input number */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
  appearance: none;
}

.dashboard-bg {
  background-color: #fafdff;
}

.select {
  background-color: #008cff !important;
  color: #ffffff;
}
</style>
